<template>
  <span>
    <Select v-model="dataId" value-key="name" placeholder="请选择" filterable clearable :multiple="multiple">
      <Option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id">
      </Option>
    </Select>
  </span>
</template>

<script>
import { Group } from '@/services/resources'

export default {
  name: 'group-picker',
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataId: this.value,
      groups: []
    }
  },
  computed: {
  },
  beforeMount () {
    this.loadData()
  },
  methods: {
    loadData () {
      Group.query().then((res) => {
        this.groups = res.data
      })
    }
  },
  watch: {
    dataId (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    value (val) {
      this.dataId = val
    }
  }
}
</script>

<style lang="scss">
</style>
